import './style.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.cta-parallax-image').forEach(image => {
    gsap.to(image, {
        yPercent: -15,
        ease: 'none',
        scrollTrigger: {
            trigger: image.closest('.cta-banner-inner'),
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
        }
    });
});
